<template>
    <div class="wrefinement-options">
        <div class="wrefinement-header">
            <span class="fleft category-name">{{ title }}</span>
            <div v-if="facetError">
                <el-icon :size="15" color="#f16868" class="el-icon-warning" />
                条件の取得に失敗しました。
            </div>
            <div
                v-else-if="nowHits > listMaxSize"
                :id="`wrefinement-form-${facetdata.facet_name}`"
            >
                <p>ヒット件数が多すぎるため表示できません。</p>
            </div>
            <div
                v-else-if="facetdata.facet_counts === 0"
                :id="`wrefinement-form-${facetdata.facet_name}`"
            >
                <p>ヒットはありません。</p>
            </div>
            <div class="buttonbox" v-else>
                <el-button
                    v-if="facetdata.facet_counts > 0 && facetdata.facet_items"
                    class="wrefinement-button"
                    size="small"
                    @click="handleClick(facetdata.facet_name)"
                    >絞り込み</el-button
                >
                <el-button
                    v-show="facetCancelButtonStatus"
                    size="mini"
                    type="default"
                    @click="resetFacet(facetdata.facet_name)"
                    round
                    >絞り込み解除</el-button
                >
            </div>
        </div>
        <el-scrollbar
            max-height="300px"
            v-if="!facetError && nowHits < listMaxSize && !facetLoading"
        >
            <div
                :id="`wrefinement-box-${facetdata.facet_name}`"
                class="wrefinement-options restricted-view"
            >
                <el-checkbox-group
                    v-model="facetItems"
                    v-if="facetdata.facet_counts > 0 && facetdata.facet_items"
                    :id="`wrefinement-form-${facetdata.facet_name}`"
                    class="facet_checkgroup"
                >
                    <template
                        v-for="(item, index) in facetdata.facet_items"
                        :key="index"
                    >
                        <el-checkbox
                            :label="`${item.item}`"
                            size="mini"
                            :value="item.item"
                            :id="`wrefinement-form-catyear-option-${index}`"
                            class="facet_checkbox"
                        >
                            <span>{{ item.item }}({{ item.hits }})</span>
                        </el-checkbox>
                    </template>
                </el-checkbox-group>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import { defineComponent, watchEffect, ref, toRef } from "vue";

export default defineComponent({
    name: "Facet",
    props: {
        title: {
            type: String,
            default: "ファセットのタイトル",
            required: true,
        },
        facetdata: {
            type: Object,
            required: true,
        },
        showFacetCancel: {
            type: Boolean,
            required: true,
        },
        listMaxSize: {
            type: Number,
            required: true,
        },
        nowHits: {
            type: Number,
            required: true,
        },
        firstFacetData: {
            type: Object,
        },
        facetError: {
            type: Boolean,
            required: true,
        },
        facetLoading: {
            type: Boolean,
            required: true,
        },
    },

    setup(props, context) {
        let facetItems = ref([]);
        const firstFacetData = toRef(props, "firstFacetData");
        if (props.firstFacetData) {
            facetItems.value = firstFacetData.value;
        }
        let facetCancelButtonStatus = ref(props.showFacetCancel);
        // 絞り込みボタンを押下された場合、その条件でファセットと検索結果を絞り込むため、親に知らせる。
        const handleClick = (facetType) => {
            if (facetItems.value.length > 0) {
                facetCancelButtonStatus.value = true;
            } else {
                facetCancelButtonStatus.value = false;
            }
            context.emit(
                "emittedFacetChange",
                facetType,
                facetItems.value,
                facetCancelButtonStatus.value
            );
            context.emit("emittedFacetItems", facetItems.value);
        };
        // 絞り込み解除ボタンを押下された場合、該当するFacetによる絞り込みを外す。
        const resetFacet = (facetType) => {
            facetCancelButtonStatus.value = false;
            facetItems.value = [];
            context.emit(
                "emittedFacetChange",
                facetType,
                facetItems.value,
                facetCancelButtonStatus.value
            );
            context.emit("emittedFacetItems", facetItems.value);
        };

        // *****************
        // watcher
        // *****************
        // Facetの状態の変更を検知し、画面に反映させるため設置した。
        watchEffect(facetCancelButtonStatus, facetItems);

        return {
            // title,
            // facetdata,
            facetItems,
            facetCancelButtonStatus,
            /* method */
            handleClick,
            resetFacet,
        };
    },
});
</script>

<style scoped>
/* wrefinement */
.wrefinement-options {
    padding: 15px 12px;
}
.wrefinement-options + .wrefinement-options {
    border-top: 1px solid #bbbbbb;
}
.wrefinement-options .hide {
    display: none;
}
.wrefinement-header {
    position: relative;
}
.wrefinement-header .category-name {
    color: #13722c;
    font-weight: bold;
    font-size: 121.42%;
    margin-bottom: 5px;
}
.wrefinement-header .wrefinement-button {
    color: #333333;
    font-size: 92.85%;
    position: absolute;
    right: 0;
    top: 0;
    padding: 1px 8px 0 15px;
    border-radius: 4px;
    border: 1px solid #999999;
    background-image: -moz-linear-gradient(
        47% 0% -90deg,
        rgb(255, 255, 255) 0%,
        rgb(229, 229, 229) 100%
    );
    background-image: -webkit-gradient(
        linear,
        47% 0%,
        47% 118%,
        color-stop(0, rgb(255, 255, 255)),
        color-stop(1, rgb(229, 229, 229))
    );
    background-image: -webkit-linear-gradient(
        -90deg,
        rgb(255, 255, 255) 0%,
        rgb(229, 229, 229) 100%
    );
    background-image: -o-linear-gradient(
        -90deg,
        rgb(255, 255, 255) 0%,
        rgb(229, 229, 229) 100%
    );
    background-image: -ms-linear-gradient(
        -90deg,
        rgb(255, 255, 255) 0%,
        rgb(229, 229, 229) 100%
    );
    background-image: linear-gradient(
        180deg,
        rgb(255, 255, 255) 0%,
        rgb(229, 229, 229) 100%
    );
    -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffffff,endColorstr=#ffe5e5e5,GradientType=0)";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffffff,endColorstr=#ffe5e5e5,GradientType=0);
    z-index: 20;
    display: block;
    cursor: pointer;
}
.wrefinement-header .wrefinement-button::before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    left: 7px;
    top: 8px;
    border: 3px solid transparent;
    border-left: 4px solid #27c0d6;
}
.wrefinement-header .wrefinement-button:hover {
    background-image: -moz-linear-gradient(
        47% 0% -90deg,
        rgb(229, 229, 229) 0%,
        rgb(255, 255, 255) 100%
    );
    background-image: -webkit-gradient(
        linear,
        47% 0%,
        47% 118%,
        color-stop(0, rgb(229, 229, 229)),
        color-stop(1, rgb(255, 255, 255))
    );
    background-image: -webkit-linear-gradient(
        -90deg,
        rgb(229, 229, 229) 0%,
        rgb(255, 255, 255) 100%
    );
    background-image: -o-linear-gradient(
        -90deg,
        rgb(229, 229, 229) 0%,
        rgb(255, 255, 255) 100%
    );
    background-image: -ms-linear-gradient(
        -90deg,
        rgb(229, 229, 229) 0%,
        rgb(255, 255, 255) 100%
    );
    background-image: linear-gradient(
        180deg,
        rgb(229, 229, 229) 0%,
        rgb(255, 255, 255) 100%
    );
    -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffe5e5e5,endColorstr=#ffffffff,GradientType=0)";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffe5e5e5,endColorstr=#ffffffff,GradientType=0);
}
.wrefinement-options ul li {
    font-size: 107.14%;
    margin-bottom: 5px;
}
.wrefinement-more {
    text-align: right;
}
.wrefinement-more a {
    font-size: 107.14%;
    background: url("../../../../public/images/icon_arrow_02.png") no-repeat 0
        6px;
    text-decoration: underline;
    padding-left: 10px;
}
span.el-checkbox__label span {
    color: #1f1f1f !important;
}
.facet_checkgroup > label {
    display: block;
    height: auto;
}
label.facet_checkbox :deep(span.el-checkbox__input) {
    vertical-align: top;
}
.facet_checkgroup > label > span.el-checkbox__label span {
    white-space: pre-line;
    vertical-align: super;
}
</style>
